// // src/hooks/klines/adapters/kucoinFutures.js

// const FUT_API = "https://api-futures.kucoin.com";
// const PROXY   = `${process.env.REACT_APP_BACKEND_URL}/proxy`;

// const log = (...a) => console.log("[kucoinFut]", ...a);

// // ---------- helpers ----------
// const toMs = (t) => {
//   const n = Number(t);
//   return Number.isFinite(n) ? (n > 1e12 ? n : n * 1000) : NaN; // авто-детект сек/мс
// };

// function fixOHLC({ time, open, high, low, close }) {
//   // Абсолютная защита от кривых значений:
//   const mx = Math.max(open, close, high, low);
//   const mn = Math.min(open, close, high, low);
//   return { time, open, high: mx, low: mn, close };
// }

// function parseFutRow(row) {
//   // KuCoin Futures документирует: [ts, open, close, high, low, vol, amount]
//   // Но фактически встречаются кейсы, где high/low меняются местами.
//   // Берём a=row[3], b=row[4] и приводим к min/max, потом фиксируем OHLC.
//   const t = row?.[0], o = row?.[1], c = row?.[2];
//   const a = row?.[3], b = row?.[4];
//   if ([t,o,c,a,b].some(v => !Number.isFinite(Number(v)))) return null;

//   const open  = Number(o);
//   const close = Number(c);
//   const v1    = Number(a);
//   const v2    = Number(b);
//   const low   = Math.min(v1, v2);
//   const high  = Math.max(v1, v2);

//   return fixOHLC({ time: toMs(t), open, high, low, close });
// }

// // ---------- interval maps ----------
// function mapGran(interval) {
//   switch (interval) {
//     case "1m": return 1;
//     case "3m": return 3;
//     case "5m": return 5;
//     case "15m": return 15;
//     case "30m": return 30;
//     case "1h": return 60;
//     case "2h": return 120;
//     case "4h": return 240;
//     case "8h": return 480;
//     case "12h": return 720;
//     case "1d": return 1440;
//     default: return 1;
//   }
// }
// function mapWsTypeLong(interval) {
//   switch (interval) {
//     case "1m": return "1min";
//     case "3m": return "3min";
//     case "5m": return "5min";
//     case "15m": return "15min";
//     case "30m": return "30min";
//     case "1h": return "1hour";
//     case "2h": return "2hour";
//     case "4h": return "4hour";
//     case "8h": return "8hour";
//     case "12h": return "12hour";
//     case "1d": return "1day";
//     default: return "1min";
//   }
// }
// function mapWsTypeShort(interval) {
//   switch (interval) {
//     case "1m": return "1m";
//     case "3m": return "3m";
//     case "5m": return "5m";
//     case "15m": return "15m";
//     case "30m": return "30m";
//     case "1h": return "1hour";
//     case "2h": return "2hour";
//     case "4h": return "4hour";
//     case "8h": return "8hour";
//     case "12h": return "12hour";
//     case "1d": return "1day";
//     default: return "1m";
//   }
// }

// // ---------- REST HISTORY ----------
// export async function kucoinFuturesFetchHistory({ symbol, interval, limit = 200 }) {
//   const gran = mapGran(interval);
//   const url = `${PROXY}/${FUT_API}/api/v1/kline/query?symbol=${symbol}&granularity=${gran}`;
//   log("REST fetch", { symbol, interval, gran, url });

//   try {
//     const r = await fetch(url, { headers: { 'ngrok-skip-browser-warning': '1' } });
//     if (!r.ok) throw new Error(`HTTP ${r.status}`);
//     const j = await r.json();
//     const arr = Array.isArray(j?.data) ? j.data : [];

//     const out = arr
//       .slice(-limit)
//       .map(parseFutRow)
//       .filter(Boolean)
//       .sort((a,b)=>a.time-b.time);

//     log("REST done", {
//       symbol, interval, gran,
//       inCount: arr.length, outCount: out.length,
//     });
//     if (out.length) {
//       const f = out[0], l = out[out.length-1];
//       const saneF = (f.high >= Math.max(f.open,f.close,f.low)) && (f.low <= Math.min(f.open,f.close,f.high));
//       const saneL = (l.high >= Math.max(l.open,l.close,l.low)) && (l.low <= Math.min(l.open,l.close,l.high));
//       log("REST sample", { first: f, last: l, saneFirst: saneF, saneLast: saneL });
//     }
//     return out;
//   } catch (e) {
//     log("REST error", e?.message || String(e));
//     return [];
//   }
// }

// // ---------- WS TOKEN CACHE ----------
// const futAuthCache = {
//   token: null,
//   endpoint: null,
//   pingInterval: 20000,
//   expiresAt: 0,
//   inflight: null,
// };

// async function getFuturesWsAuthOnce() {
//   const now = Date.now();
//   if (futAuthCache.token && now < futAuthCache.expiresAt) {
//     return {
//       token: futAuthCache.token,
//       endpoint: futAuthCache.endpoint,
//       pingInterval: futAuthCache.pingInterval,
//     };
//   }
//   if (futAuthCache.inflight) return futAuthCache.inflight;

//   futAuthCache.inflight = (async () => {
//     const tokenUrl = `${PROXY}/${FUT_API}/api/v1/bullet-public`;
//     const r = await fetch(tokenUrl, { method: "POST", headers: { 'ngrok-skip-browser-warning': '1' } });
//     if (!r.ok) throw new Error(`token HTTP ${r.status}`);

//     const j = await r.json();
//     const servers = j?.data?.instanceServers || [];
//     const token   = j?.data?.token;
//     if (!servers.length || !token) throw new Error("token empty");
//     const { endpoint, pingInterval = 20000 } = servers[0];

//     futAuthCache.token        = token;
//     futAuthCache.endpoint     = endpoint;
//     futAuthCache.pingInterval = pingInterval;
//     futAuthCache.expiresAt    = now + 23 * 60 * 60 * 1000;

//     log("WS auth cached", { endpoint, pingInterval });
//     return { token, endpoint, pingInterval };
//   })().finally(() => { futAuthCache.inflight = null; });

//   return futAuthCache.inflight;
// }

// // ---------- WS OPEN ----------
// /**
//  * onBar({ time(ms), open, high, low, close })
//  */
// export function kucoinFuturesOpenWS({ symbol, interval, onBar }) {
//   let ws = null;
//   let pingTimer = null;
//   let welcomed = false;
//   let subscribed = false;

//   const cleanup = () => {
//     try { clearInterval(pingTimer); } catch {}
//     try { ws?.close(1000, "kucoin futures close"); } catch {}
//     ws = null;
//     log("onclose");
//   };

//   (async () => {
//     try {
//       const auth = await getFuturesWsAuthOnce();

//       const typeLong   = mapWsTypeLong(interval);
//       const typeShort  = mapWsTypeShort(interval);
//       const topicLimit = `/contractMarket/limitCandle:${symbol}_${typeLong}`;
//       const topicCndl  = `/contractMarket/candle${typeShort}:${symbol}`;

//       const wsUrl = `${auth.endpoint}?token=${encodeURIComponent(auth.token)}&connectId=${Date.now()}`;
//       ws = new WebSocket(wsUrl);

//       ws.onopen = () => {
//         log("open", { symbol, interval, wsUrl, topicLimit, topicCndl });
//         // heartbeat
//         pingTimer = setInterval(() => {
//           try { ws?.send(JSON.stringify({ id: Date.now(), type: "ping" })); } catch {}
//         }, Math.max(5000, auth.pingInterval || 20000));
//       };

//       const doSubscribeOnce = () => {
//         if (!ws || subscribed) return;
//         const subs = [
//           { id: Date.now(),     type: "subscribe", topic: topicLimit, privateChannel: false, response: true },
//           { id: Date.now() + 1, type: "subscribe", topic: topicCndl,  privateChannel: false, response: true },
//         ];
//         subs.forEach(s => { try { ws.send(JSON.stringify(s)); } catch {} log("→ SUB", s); });
//         subscribed = true;
//       };

//       ws.onmessage = (ev) => {
//         let msg; try { msg = JSON.parse(ev.data); } catch { return; }

//         if (msg?.type === "welcome") { welcomed = true; log("first msg: welcome"); doSubscribeOnce(); return; }
//         if (msg?.type === "pong" || msg?.type === "ack") return;

//         if (msg?.type === "message" && msg?.topic && msg?.data?.candles) {
//           // candles = [ts, open, close, X, Y, ...]  где X/Y = high/low в произвольном порядке
//           const k = msg.data.candles;
//           const parsed = parseFutRow(k);
//           if (parsed) {
//             const bar = fixOHLC(parsed);  // доп. страховка на WS
//             onBar && onBar(bar);

//             // sanity лог раз в ~5 минутных бакетов, чтобы не спамить:
//             if ((bar.time % (5 * 60_000)) === 0) {
//               const sane = (bar.high >= Math.max(bar.open,bar.close,bar.low)) && (bar.low <= Math.min(bar.open,bar.close,bar.high));
//               log("msg candle", { topic: msg.topic, bar, sane });
//             }
//           } else {
//             log("skip msg (bad candles)", { topic: msg?.topic, candles: k });
//           }
//         }
//       };

//       ws.onerror = (e) => log("error", e);
//       ws.onclose = cleanup;

//     } catch (e) {
//       log("init error:", e?.message || String(e));
//       cleanup();
//     }
//   })();

//   return cleanup;
// }
/* eslint-disable max-len */
const PROXY   = `${process.env.REACT_APP_BACKEND_URL}/proxy`;
const FUT_API = "https://api-futures.kucoin.com";

const log = (...a) => console.log("[kucoinFut]", ...a);

const toMs = (t) => {
  const n = Number(t);
  return Number.isFinite(n) ? (n > 1e12 ? n : n * 1000) : NaN;
};

function fixOHLC({ time, open, high, low, close }) {
  return { time, open, high: Math.max(open, close, high, low), low: Math.min(open, close, high, low), close };
}

function parseFutRow(row) {
  // [tsSec, open, close, high, low, vol, amount]
  const t = row?.[0], o = row?.[1], c = row?.[2], h = row?.[3], l = row?.[4];
  if ([t,o,c,h,l].some(v => !Number.isFinite(Number(v)))) return null;
  return fixOHLC({ time: toMs(t), open: +o, high: +h, low: +l, close: +c });
}

function mapGran(interval) {
  switch (interval) {
    case "1m": return 1;   case "3m": return 3;   case "5m": return 5;
    case "15m": return 15; case "30m": return 30; case "1h": return 60;
    case "2h": return 120; case "4h": return 240; case "8h": return 480;
    case "12h": return 720; case "1d": return 1440;
    default: return 1;
  }
}
function mapWsTypeLong(interval) {
  switch (interval) {
    case "1m": return "1min"; case "3m": return "3min"; case "5m": return "5min";
    case "15m": return "15min"; case "30m": return "30min"; case "1h": return "1hour";
    case "2h": return "2hour"; case "4h": return "4hour"; case "8h": return "8hour";
    case "12h": return "12hour"; case "1d": return "1day"; default: return "1min";
  }
}
function mapWsTypeShort(interval) {
  switch (interval) {
    case "1m": return "1m"; case "3m": return "3m"; case "5m": return "5m";
    case "15m": return "15m"; case "30m": return "30m"; case "1h": return "1hour";
    case "2h": return "2hour"; case "4h": return "4hour"; case "8h": return "8hour";
    case "12h": return "12hour"; case "1d": return "1day"; default: return "1m";
  }
}

/** Жёстко нормализуем endpoint к официальному фьючерсному хосту */
function normalizeKucoinFutEndpoint(endpoint) {
  try {
    const u = new URL(endpoint);
    if (!u.hostname.endsWith("kucoin.com")) {
      u.hostname = "ws-api-futures.kucoin.com";
      u.protocol = "wss:";
    }
    return u.toString();
  } catch {
    return "wss://ws-api-futures.kucoin.com";
  }
}

// ---------- REST HISTORY ----------
export async function kucoinFuturesFetchHistory({ symbol, interval, limit = 200 }) {
  const gran = mapGran(interval);
  const url = `${PROXY}/${FUT_API}/api/v1/kline/query?symbol=${symbol}&granularity=${gran}`;
  log("REST fetch", { symbol, interval, gran, url });

  try {
    const r = await fetch(url, { headers: { 'ngrok-skip-browser-warning': '1' } });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    const j = await r.json();
    const arr = Array.isArray(j?.data) ? j.data : [];

    const out = arr
      .slice(-limit)
      .map(parseFutRow)
      .filter(Boolean)
      .sort((a,b)=>a.time-b.time);

    log("REST done", { symbol, interval, gran, inCount: arr.length, outCount: out.length });
    return out;
  } catch (e) {
    log("REST error", e?.message || String(e));
    return [];
  }
}

// ---------- WS TOKEN CACHE ----------
const futAuthCache = { token: null, endpoint: null, pingInterval: 20000, expiresAt: 0, inflight: null };

async function getFuturesWsAuthOnce() {
  const now = Date.now();
  if (futAuthCache.token && now < futAuthCache.expiresAt) {
    return { token: futAuthCache.token, endpoint: futAuthCache.endpoint, pingInterval: futAuthCache.pingInterval };
  }
  if (futAuthCache.inflight) return futAuthCache.inflight;

  futAuthCache.inflight = (async () => {
    const tokenUrl = `${PROXY}/${FUT_API}/api/v1/bullet-public`;
    const r = await fetch(tokenUrl, { method: "POST", headers: { 'ngrok-skip-browser-warning': '1' } });
    if (!r.ok) throw new Error(`token HTTP ${r.status}`);

    const j = await r.json();
    const servers = j?.data?.instanceServers || [];
    const token   = j?.data?.token;
    if (!servers.length || !token) throw new Error("token empty");

    const endpoint = normalizeKucoinFutEndpoint(servers[0].endpoint);
    const pingInterval = Number(servers[0]?.pingInterval || 20000);

    futAuthCache.token        = token;
    futAuthCache.endpoint     = endpoint;
    futAuthCache.pingInterval = pingInterval;
    futAuthCache.expiresAt    = now + 23 * 60 * 60 * 1000;

    log("WS auth cached", { endpoint, pingInterval });
    return { token, endpoint, pingInterval };
  })().finally(() => { futAuthCache.inflight = null; });

  return futAuthCache.inflight;
}

// ---------- WS OPEN (kline) ----------
export function kucoinFuturesOpenWS({ symbol, interval, onBar }) {
  let ws = null;
  let pingTimer = null;
  let subscribed = false;

  const cleanup = () => {
    try { clearInterval(pingTimer); } catch {}
    try { ws?.close(1000, "kucoin futures close"); } catch {}
    ws = null;
    log("onclose");
  };

  (async () => {
    try {
      const auth = await getFuturesWsAuthOnce();

      const typeLong   = mapWsTypeLong(interval);
      const typeShort  = mapWsTypeShort(interval);
      const topicLimit = `/contractMarket/limitCandle:${symbol}_${typeLong}`;
      const topicCndl  = `/contractMarket/candle${typeShort}:${symbol}`;

      const u = new URL(auth.endpoint);
      u.searchParams.set("token", auth.token);
      u.searchParams.set("connectId", String(Date.now()));
      const wsUrl = u.toString();

      ws = new WebSocket(wsUrl);

      ws.onopen = () => {
        log("open", { symbol, interval, wsUrl, topicLimit, topicCndl });
        pingTimer = setInterval(() => {
          try { ws?.send(JSON.stringify({ id: Date.now(), type: "ping" })); } catch {}
        }, Math.max(5000, (auth.pingInterval || 20000) - 1000));
      };

      const doSubscribeOnce = () => {
        if (!ws || subscribed) return;
        const subs = [
          { id: Date.now(),     type: "subscribe", topic: topicLimit, privateChannel: false, response: true },
          { id: Date.now() + 1, type: "subscribe", topic: topicCndl,  privateChannel: false, response: true },
        ];
        subs.forEach(s => { try { ws.send(JSON.stringify(s)); } catch {} log("→ SUB", s); });
        subscribed = true;
      };

      ws.onmessage = (ev) => {
        let msg; try { msg = JSON.parse(ev.data); } catch { return; }

        if (msg?.type === "welcome") { doSubscribeOnce(); return; }
        if (msg?.type === "pong" || msg?.type === "ack") return;

        if (msg?.type === "message" && msg?.topic && msg?.data?.candles) {
          const k = msg.data.candles; // [ts, open, close, high, low, ...]
          if (Array.isArray(k) && k.length >= 5) {
            const row = parseFutRow(k);
            if (row) onBar?.(row);
          }
        }
      };

      ws.onerror = (e) => log("error", e);
      ws.onclose = cleanup;

    } catch (e) {
      log("init error:", e?.message || String(e));
      cleanup();
    }
  })();

  return cleanup;
}
